import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromFormConfiguration from './form-configuration.reducers';

export interface FormConfigurationState {
  stateData: fromFormConfiguration.State;
}

export interface State extends fromRoot.AppState {
  formConfiguration: FormConfigurationState;
}

export const reducers = {
  stateData: fromFormConfiguration.reducer
};

export const selectFormConfigurationState = createFeatureSelector<FormConfigurationState>('formConfiguration');

export const selectFormConfigurationStateData = createSelector(selectFormConfigurationState, (state: FormConfigurationState) => state.stateData);

export const getFormConfigurationState = createSelector(selectFormConfigurationStateData, fromFormConfiguration.getStateData);

export const getFormConfigurationScreenError = createSelector(selectFormConfigurationStateData, fromFormConfiguration.getError);

export const getFormConfigurationScreenPending = createSelector(selectFormConfigurationStateData, fromFormConfiguration.getPending);